<template>
  <b-col cols="12">
    <b-progress :max="max" height="1rem" variant="mint" class="my-1">
      <b-progress-bar
        :value="currentBalance"
        variant="mint"
        :label="showValue ? '100%' : null"
      ></b-progress-bar>
      <b-progress-bar :value="add" variant="mint" striped></b-progress-bar>
    </b-progress>
  </b-col>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    max: {
      type: Number,
      required: true
    },
    currentBalance: {
      type: Number,
      default: 0
    },
    add: {
      type: Number,
      default: 0
    },
    showValue: {
      type: Boolean,
      default: false
    }
  }
}
</script>
